import telegramIcon from '../images/svg/telegram.svg'
import discordIcon from '../images/svg/discord-icon.svg'
import linkedinIcon from '../images/svg/LinkedIn_icon.svg'
import redditIcon from '../images/svg/reddit_icon.svg'

const communitiesData = [
    {
        imgAuthor: telegramIcon,
        name: "Telegram",
        link: 'http://telegram.tedcrypto.io',
        buttonLabel: 'Join Us',
    },
    {
        imgAuthor: discordIcon,
        name: "Discord",
        link: 'http://discord.tedcrypto.io',
        buttonLabel: 'Join Us',
    },
    {
        imgAuthor: linkedinIcon,
        name: "LinkedIn",
        link: 'https://www.linkedin.com/company/tedcryptoio',
        buttonLabel: 'Join Us',
    },
    {
        imgAuthor: redditIcon,
        name: "Reddit",
        link: 'https://www.reddit.com/r/tedcrypto/',
        buttonLabel: 'Join Us',
    },
]

export default communitiesData;
